<template>
  <div class="home-hero-container">

    <div class="container page-wrapper">
      <div class="inner-content">
        <h1>
          Take the guesswork out of financing
        </h1>
        <p>
          Matching Registered Investment Advisors (RIAs), IBD advisors, independent and captive insurance agents, and tax practices with the right lending solution for an optimized outcome
        </p>

        <div class="button-group">
          <router-link
            :to="{ name: 'ChooseDealType' }"
            class="default-btn green subdued-hover"
          >Find a Lender</router-link>

          <button
            v-if="$vuetify.breakpoint.smAndUp"
            class="default-btn green inverse"
            @click="showYoutubeWindow">
            <v-icon v-if="$vuetify.breakpoint.lgAndUp">mdi-play</v-icon>
            Watch Video
          </button>
        </div>

        <img src="@/modules/home/assets/wealth-management-finalist.png" />
      </div>
    </div>

    <div
      v-if="showYoutubeVideo"
      class="youtube-wrapper"
    >
      <button
        class="default-btn text close"
        @click="closeYoutubeWindow()"
      ><v-icon>mdi-window-close</v-icon></button>

      <iframe
        width="100%" height="100%" frameborder="0"
        src="https://www.youtube.com/embed/kiDpBuRGNCM"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeHero',
  data: () => ({
    showYoutubeVideo: false,
  }),
  created () {
    document.addEventListener('keyup', this.closeYoutubeWindow)
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.closeYoutubeWindow)
  },
  methods: {
    showYoutubeWindow () {
      this.showYoutubeVideo = true
    },

    closeYoutubeWindow (event) {
      if (!event) {
        this.showYoutubeVideo = false
        return
      }

      if (event.key === 'Escape') this.showYoutubeVideo = false
    },
  },
}
</script>

<style lang="scss" scoped>
.home-hero-container {
  height: 460px;
  padding-top: 80px;

  background-color: #1A4153;

  @include md {
    height: 550px;
    background: {
      image: url("~@/modules/home/assets/home-hero.png");
      size: cover;
      position: center center;
      repeat: no-repeat;
    };
  }

  @include lg {
    height: 760px;
  }

  @include xl {
    height: 880px;
    background-image: url("~@/modules/home/assets/home-hero@2x.png");
  }

  .container, .inner-content {
    height: 100%;
  }

  .inner-content {
    position: relative;

    max-width: 570px;
    padding-bottom: 80px;

    display: flex;
    flex-direction: column;
    justify-content: center;

    @include md {
      padding-bottom: 0;
    }

    @include xl {
      padding-bottom: 20px;
    }

    img {
      position: absolute;
      z-index: 2;
      bottom: 0px;
      left: 0px;
      right: 0px;

      width: 200px;
      height: auto;
      margin: 0 auto;

      @include md {
        left: 185px;
        right: initial;
        width: 230px;
      }

      @include lg {
        bottom: 40%;
        left: initial;
        right: -35vw;
        width: 300px;
      }

      @include xl {
        bottom: 20px;
        left: 0px;
        right: initial;
        width: 280px;
      }
    }
  }

  h1 {
    color: white;
    letter-spacing: 1.9px;
  }

  p {
    margin-top: 10px;
    margin-bottom: 10px;

    color: white;
    font-family: "Avenir Book";
    letter-spacing: 0.12px;
    line-height: 20px;
  }

  .button-group {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;

    .default-btn {
      height: 50px;
      width: 150px;
      margin-bottom: 15px;
      padding: 0;

      @include mdAndBelow {
        min-height: 35px;
        font-size: 14px;
        width: 160px;
      }

      &:not(:disabled).green.inverse {
        border-color: white !important;
        padding: 0 10px !important;
      }
    }
  }

  @include smOnly {
    .button-group {
      justify-content: center;
    }
  }

  @include md {
    height: 410px;

    .inner-content {
      max-width: 390px;
    }

    p {
      margin-top: 15px;
      margin-bottom: 30px;

      font-size: 14px;
    }

    .button-group {
      flex-direction: column;
      width: 250px;

      button { flex-grow: 1; }
    }
  }

  @include lg {
    height: 540px;

    .inner-content {
      max-width: 430px;
    }

    h1 {
      font-size: 36px;
      line-height: 42px;
    }

    p {
      margin-top: 25px;
      margin-bottom: 40px;

      font-size: 22px;
      line-height: 30px;
    }

    .button-group {
      flex-direction: row;
      width: auto;

      .default-btn {
        flex-grow: 0;
        width: 210px;
      }
    }
  }

  @include xl {
    height: 750px;

    .inner-content {
      max-width: 570px;
    }

    h1 {
      font-size: 48px;
      line-height: 55px;
    }

    p {
      font-size: 24px;
    }
  }
}

.youtube-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  padding: 5%;

  background-color: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .default-btn.close {
    position: absolute;
    top: 1%;
    right: 1%;

    color: white !important;
  }
}

::v-deep {
  .v-icon.mdi-play {
    font-size: 36px !important;
  }
}
</style>
